import {
  getGlobalCssUrl,
  getComponentCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createPropertyContainerTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('PropertyContainer--wc.css')}" rel="stylesheet" />
`
  return t
}

// Getter function for template
const getTemplatePropertyContainerStyles = () => createPropertyContainerTemplate()
export { getTemplatePropertyContainerStyles }
